import { DictionaryType } from '../../common/types';
import { getUrlWithId, useGetFetch } from '../../utils/reactQuery';
import { pathToUrl } from '../../utils/router';
import { ApiRoutesEnum } from '../../utils/routes';

export type FetchDictionaryResponseType = DictionaryType[];

export const useGetDictionaryByName = (name: string) =>
  useGetFetch<FetchDictionaryResponseType>({
    url: pathToUrl(getUrlWithId(ApiRoutesEnum.getDictionaries, name)),
    config: { enabled: !!name },
  });
